import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { ID } from "@types";
import {
  getProviderServicesCount,
  IProviderServicesCount,
} from "../services/serviceProviders";

interface IUseServiceProviderOptions {
  includes: "user"[];
}

export const useProviderServicesCount = (
  serviceProviderId: ID | undefined,
  options?: IUseServiceProviderOptions
) => {
  const {
    data: servicesCount,
    isLoading,
    isError,
    isSuccess,
    status,
  } = useDataQuery<IProviderServicesCount>(
    ["serviceProvider", Number(serviceProviderId), options],
    () =>
      getProviderServicesCount(serviceProviderId, options).then(
        ({ data }) => data
      ),
    {
      enabled: !!serviceProviderId,
    }
  );

  return { servicesCount, isLoading, isError, isSuccess, status };
};
